module.exports = __webpack_public_path__ + "img/product-detail-promo-bg.6594d22.jpg";